/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Convert_Timecode_DescriptionInputs */



/**
* | output |
* | --- |
* | "Convert timecode settings and options" |
*
* @param {Convert_Timecode_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const convert_timecode_description = /** @type {((inputs?: Convert_Timecode_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Convert_Timecode_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Convertir les paramètres et options de timecode")
	if (locale === "de") return /** @type {LocalizedString} */ ("Timecode-Einstellungen und -Optionen konvertieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Converti le impostazioni e le opzioni del timecode")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Преобразовать настройки и параметры таймкода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Convertir configuraciones y opciones de código de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("转换时间码设置和选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコードの設定とオプションを変換する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमकोड सेटिंग्स और विकल्पों को बदलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Converter configurações e opções de código de tempo")
	return /** @type {LocalizedString} */ ("Convert timecode settings and options")
});